export const stuassessmentApi = {
    heading:[
        {
            head:"Student ID"
        },
        {
            head:"Name"
        },
        {
            head:"Top Five Assessment"
        },
        {
            head:"Total"
        },
    ],
    data:[
        {
            
        },
        {
            
        },
        {
            
        },
        {
            
        },
        {
            
        },
        {
            
        },
        {
            
        },
        {
            
        },
        {
            
        },
        {
            
        },
        {
            
        },
        {
            
        },
        {
            
        },
        {
            
        },
        {
            
        },
        {
            
        },
        {
            
        },
        {
            
        },
        {
            
        },
        {
            
        },
        {
            
        },
        {
            
        },
        {
            
        },
        {
            
        },
        {
            
        },
        
        
    ]
}